import React from 'react';
import { Section } from './shared';
const bonuses = [{
  num: '01',
  title: 'Guiones de WhatsApp para Situaciones Difíciles',
  text: '20 guiones listos para copiar y pegar en WhatsApp Business para las situaciones más incómodas: clientes que piden descuento, consultas fuera de horario, siniestros urgentes, clientes que amenazan con irse. Nunca más quedarte sin palabras.',
  value: '$8.000'
}, {
  num: '02',
  title: 'Calculadora de Comisiones PRO',
  text: 'Planilla Excel con fórmulas para calcular tu comisión real por póliza, el impacto de la inflación en tu cartera y la proyección de ingresos con el nuevo sistema de trabajo. Completás tus números y te dice exactamente cuánto podés ganar.',
  value: '$9.000'
}, {
  num: '03',
  title: 'Biblioteca de Prompts de Seguros Express',
  text: 'Los 10 prompts más usados para cotizaciones, seguimientos y renovaciones listos en una sola hoja de referencia rápida. Imprimible. Para tener al lado del teclado.',
  value: '$8.000'
}, {
  num: '04',
  title: 'Plantillas de Mail Profesional',
  text: '15 mails listos para las situaciones más frecuentes: seguimiento de cotización, recordatorio de renovación, comunicación de siniestro, respuesta a objeciones y más. Solo cambiás el nombre y enviás.',
  value: '$10.000'
}];
export function Bonuses() {
  return <Section className="bg-white py-16 sm:py-20" data-id="element-17" data-mp="3n67pipzpn4fd">
      <h2 className="text-center font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-18" data-mp="3n7iswop8ua5y">
        4 Bonos estratégicos
      </h2>
      <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-19" data-mp="2uh0uw23dmyze">
        {bonuses.map(b => <div key={b.num} className="relative flex flex-col rounded-2xl border-2 border-gold/40 bg-gradient-to-b from-amber-50/60 to-white p-6" data-id="element-20" data-mp="38g8vmzf6uf5p">
            <div className="flex items-start justify-between gap-4" data-id="element-21" data-mp="33ge3ytnl9ljl">
              <span className="font-display text-3xl font-extrabold text-gold" data-id="element-22" data-mp="npi3eb9zxus4">{b.num}</span>
              <div className="text-right" data-id="element-23" data-mp="ir6rzw41zc7s">
                <span className="block text-sm text-slate-400 line-through" data-id="element-24" data-mp="iqex6nia5iik">Valor: {b.value}</span>
                <span className="font-display text-lg font-extrabold text-brandgreen" data-id="element-25" data-mp="3ciell2ggpsyk">GRATIS</span>
              </div>
            </div>
            <h3 className="mt-3 font-display text-base font-bold text-navy" data-id="element-26" data-mp="3hju52q2zrreu">{b.title}</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-27" data-mp="3lhi9qkuhkyjx">{b.text}</p>
          </div>)}
      </div>
    </Section>;
}